module.exports = __webpack_public_path__ + "website/img/VIP.6322b529.svg";